/* Shared slug → photo map (Phase 3b). Extracted from ServicePage. */
import imgElectricalPanel from "@/assets/electrical-panel.webp";
import imgElectricalConduit from "@/assets/electrical-conduit.webp";
import imgManufacturingFloor from "@/assets/manufacturing-floor.webp";
import imgMotorControlCenter from "@/assets/motor-control-center.webp";
import imgGenerator1 from "@/assets/generator-install-1.webp";
import imgGenerator2 from "@/assets/generator-install-2.webp";
import imgDataCabling from "@/assets/data-cabling.webp";
import imgDesignBuild from "@/assets/design-build.webp";
import imgNewConstruction from "@/assets/new-construction.webp";
import imgHvacMaintenance from "@/assets/blog/hvac-maintenance.jpg";
import imgElectricalRepair from "@/assets/blog/commercial-electrical-repair-common-issues.webp";
import imgLicensedElectrician from "@/assets/blog/licensed-electrician.jpg";
import imgDuctwork1 from "@/assets/hvac-ductwork-1.webp";
import imgDuctwork2 from "@/assets/hvac-ductwork-2.webp";
import imgDuctwork3 from "@/assets/hvac-ductwork-3.webp";
import imgThermostat from "@/assets/thermostat-controls.webp";
import imgWalkInCooler from "@/assets/walk-in-cooler.webp";
import imgNewConstructionHvac from "@/assets/new-construction-hvac.webp";
import imgResidentialHvac from "@/assets/residential-hvac.webp";
import imgGasFurnace from "@/assets/blog/gas-furnace-maintenance-checklist-kentucky.jpg";
import imgLightingRetrofit from "@/assets/lighting-retrofit.webp";
import imgLightingDesign from "@/assets/lighting-design.webp";
import imgEnergyAudit from "@/assets/energy-audit.webp";
import imgEnergyConsulting from "@/assets/energy-consulting.webp";
import imgUtilityMeters from "@/assets/utility-meters.webp";
import imgPerformanceContract from "@/assets/performance-contract.webp";
import imgOutdoorLighting from "@/assets/blog/outdoor-lighting.jpg";
import imgSchoolLighting from "@/assets/school-lighting.webp";
import imgFootballStadium from "@/assets/football-stadium.webp";
import imgBaseballField from "@/assets/baseball-field.webp";
import imgBasketballLighting from "@/assets/basketball-lighting.webp";
import imgArenaLighting from "@/assets/arena-lighting.webp";
import imgSouthernHigh from "@/assets/southern-high-school.webp";
import imgHospital from "@/assets/hospital-facility.webp";
import imgDataCenter from "@/assets/data-center.webp";
import imgWarehouseFloor from "@/assets/warehouse-floor.webp";
import imgAutomotivePlant from "@/assets/automotive-plant.webp";
import imgFoodProcessing from "@/assets/food-processing.webp";
import imgRestaurant from "@/assets/restaurant-electrical.webp";
import imgAloftHotel from "@/assets/aloft-hotel.webp";
import imgLittleFlockChurch from "@/assets/little-flock-church.webp";
import imgBeuchelBasin from "@/assets/beuchel-basin.webp";
import imgHardinCountyWater from "@/assets/hardin-county-water.webp";
import imgUoflLabs from "@/assets/uofl-research-labs.webp";
import imgFreedomHall from "@/assets/freedom-hall.webp";

// Licensed stock photography — Unsplash standard license (free for commercial use, no attribution required).
// These are illustrative stock, not Hadley job photography. Source IDs recorded for provenance.
//   soccer-field-lighting: photo-1487466365202-1afdb86c764e
//   sports-field-lighting: photo-1517747614396-d21a78b850e8
//   tennis-court-lighting: photo-1780663684798-150dc8879380
//   track-field-lighting:  photo-1770698693897-ee89c1f7aea2
import soccerFieldLightingAsset from "@/assets/stadium/soccer-field-lighting.webp.asset.json";
import sportsFieldLightingAsset from "@/assets/stadium/sports-field-lighting.webp.asset.json";
import tennisCourtLightingAsset from "@/assets/stadium/tennis-court-lighting.webp.asset.json";
import trackFieldLightingAsset from "@/assets/stadium/track-field-lighting.webp.asset.json";

export const heroPhotos: Record<string, string | null> = {
  // Electrical
  "commercial-electrical-contractor": imgElectricalConduit,
  "industrial-electrical-contractor": imgManufacturingFloor,
  "electrical-service-and-repair": imgElectricalConduit,
  "preventative-maintenance": imgMotorControlCenter,
  "generator-installation": imgGenerator1,
  "commercial-generators": imgGenerator2,
  "emergency-electrical-service": imgElectricalPanel,
  "electrical-panel-upgrades": imgElectricalPanel,
  "motor-control-centers": imgMotorControlCenter,
  "plc-motor-controls": imgMotorControlCenter,
  "fire-alarm-systems": null,
  "electrical-safety-inspections": imgLicensedElectrician,
  "data-cabling-low-voltage": imgDataCabling,
  "electrical-design-build": imgDesignBuild,
  "high-voltage-electrical": imgElectricalPanel,
  "switchgear-installation": imgElectricalPanel,
  "transformer-installation": imgBeuchelBasin,
  "arc-flash-studies": imgElectricalRepair,
  "ev-charger-installation": imgNewConstruction,
  // HVAC
  "commercial-hvac": imgDuctwork1,
  "residential-hvac": imgResidentialHvac,
  "building-automation-systems": imgThermostat,
  "hvac-installation": imgNewConstructionHvac,
  "industrial-hvac": imgDuctwork2,
  "ac-installation-repair": imgHvacMaintenance,
  "furnace-installation-repair": imgGasFurnace,
  "heat-pump-installation": null,
  "ductwork-installation": imgDuctwork3,
  "hvac-service-repair": imgHvacMaintenance,
  "hvac-preventative-maintenance": imgDuctwork2,
  "temperature-controls": imgThermostat,
  "commercial-refrigeration": imgWalkInCooler,
  "geothermal-heating-cooling": null,
  "indoor-air-quality": imgDuctwork3,
  "ductless-mini-split": null,
  // Energy
  "lighting-design": imgLightingDesign,
  "lighting-retrofits": imgLightingRetrofit,
  "energy-audits": imgEnergyAudit,
  "energy-bill-analysis": imgUtilityMeters,
  "guaranteed-energy-savings": imgPerformanceContract,
  "energy-efficiency-consulting": imgEnergyConsulting,
  "lighting-controls": imgLightingDesign,
  "outdoor-commercial-lighting": imgOutdoorLighting,
  // Industries
  "manufacturing-electrical": imgManufacturingFloor,
  "warehouse-electrical": imgWarehouseFloor,
  "healthcare-facility-compliance": imgHospital,
  "healthcare-electrical": imgHospital,
  "school-electrical-contractor": imgSchoolLighting,
  "church-electrical-contractor": imgLittleFlockChurch,
  "hotel-electrical-contractor": imgAloftHotel,
  "restaurant-electrical": imgRestaurant,
  "municipal-electrical": imgHardinCountyWater,
  "water-treatment-electrical": imgHardinCountyWater,
  "data-center-electrical": imgDataCenter,
  "food-beverage-manufacturing": imgFoodProcessing,
  "automotive-plant-electrical": imgAutomotivePlant,
  "university-electrical": imgUoflLabs,
  "stadium-arena-electrical": imgArenaLighting,
  // Stadium & sports lighting
  "stadium-lighting-design": imgFootballStadium,
  "sports-field-lighting": sportsFieldLightingAsset.url,
  "led-stadium-retrofits": imgFootballStadium,
  "arena-event-lighting": imgArenaLighting,
  "outdoor-sports-lighting": imgFootballStadium,
  "football-stadium-lighting": imgFootballStadium,
  "baseball-field-lighting": imgBaseballField,
  "basketball-arena-lighting": imgBasketballLighting,
  "soccer-field-lighting": soccerFieldLightingAsset.url,
  "tennis-court-lighting": tennisCourtLightingAsset.url,
  "track-field-lighting": trackFieldLightingAsset.url,
  "high-school-athletic-lighting": imgSouthernHigh,
  "recreational-park-lighting": imgFootballStadium,
};

export const heroPhotoFallback: Record<string, string> = {
  "/electrical-services": imgElectricalPanel,
  "/hvac-services": imgDuctwork1,
  "/energy-management": imgLightingRetrofit,
  "/industries": imgManufacturingFloor,
  "/stadium-sports-lighting": imgFreedomHall,
};

export const heroPhotoAlts: Record<string, string> = {
  "plc-motor-controls": "Open motor control center cabinet with controls and relays",
  "electrical-safety-inspections": "Licensed electrician standing beneath commercial electrical conduit",
  "high-voltage-electrical": "Row of electrical switchgear and power distribution cabinets",
  "switchgear-installation": "Row of electrical switchgear and power distribution cabinets",
  "arc-flash-studies": "Technician working inside an energized electrical panel",
  "ac-installation-repair": "HVAC technician servicing an outdoor air conditioning condenser",
  "furnace-installation-repair": "HVAC technician inspecting a residential gas furnace",
  "hvac-service-repair": "HVAC technician servicing an outdoor air conditioning condenser",
  "outdoor-commercial-lighting": "Commercial parking lot illuminated by outdoor lights at dusk",
  "outdoor-sports-lighting": "Football field illuminated by stadium lights at night",
  "recreational-park-lighting": "Football field illuminated by stadium lights at night",
  "soccer-field-lighting": "Soccer field illuminated by sports lighting at night",
  "sports-field-lighting": "Sports field illuminated at night by pole-mounted field lighting",
  "tennis-court-lighting": "Tennis courts illuminated at night by court lighting",
  "track-field-lighting": "Running track and field illuminated at night by sports lighting",
};

export const heroPhotoFallbackAlts: Record<string, string> = {
  "/electrical-services": "Row of electrical switchgear and power distribution cabinets",
  "/hvac-services": "Installed commercial HVAC ductwork inside a facility",
  "/energy-management": "Warehouse shown before and after an LED lighting retrofit",
  "/industries": "Electrical systems serving an industrial manufacturing floor",
  "/stadium-sports-lighting": "Freedom Hall arena illuminated for an indoor event",
};
